import * as React from 'react';

import { Footer } from '../Components/Footer/Footer';
import styled from 'styled-components';
import { ProgramContext, SettingsContext } from '../Context';
import { useContext } from 'react';
import { filter, map, reduce } from 'lodash';
import { useEffect } from 'react';
import { Database } from '../Managers/DataManager';
import { useHistory } from 'react-router';
import { useState } from 'react';
import { CircularProgress, Fade } from '@material-ui/core';


const Container = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start
justify-content: flex-start;
min-height: 100vh;

@media (min-width: 991px){
    margin-left: 80px;
    margin-right: 80px;
}

@media (max-width: 990px ){
    margin-left: 40px;
    margin-right: 40px;
}

@media(max-width: 767px){
    margin-right: 40px;
    margin-left: 40px;
}

@media(max-width: 480px){
    margin-right: 20px;
    margin-left: 20px;
}
`

const Title = styled.h1`
    color: white;
    font-size: 1.4em;
    font-weight: bold;

`

const Inner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
`

const Banner = styled.img`

    margin: 0.6vw;
    object-fit: cover;
    flex: 1;
    opacity: ${(props: {loaded: boolean, delay: string}) => props.loaded ? 1 : 0};
    transition: all 0.3s ${(props: {loaded: boolean, delay: string}) => props.delay} ease-in-out;
    @media (min-width: 991px){
        width: calc((100vw - (160px + 3vw)) / 4);
    }

    @media (max-width: 990px){
        width: calc((100vw - (80px + 3vw)) / 4);
    }

    @media (max-width: 767px){
        width: calc((100vw - (40px + 3vw)) / 4);
    }


    @media (max-width: 480px){
        display: none;
    }

`

const Poster = styled.img`


    margin: 0.6vw;
    object-fit: cover;
    flex: 1;
    
    opacity: ${(props: {loaded: boolean, delay: string}) => props.loaded ? 1 : 0};
    transition: opacity 0.3s ${(props: {loaded: boolean, delay: string}) => props.delay} ease-in-out;

    @media (min-width: 991px){
        width: calc((100vw - (160px + 3vw)) / 4);
    }

    @media (max-width: 990px){
        width: calc((100vw - (80px + 3vw)) / 4);
    }

    @media (max-width: 767px){
        width: calc((100vw - (40px + 3vw)) / 4);
    }

    @media (max-width: 374px){
        width: calc((100vw - (40px + 3vw)) / 3);
    }

    @media (min-width: 481px){
        display: none;
    }

`

const Center = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    
`

export const Programs = () => {


    const [visible, setVisibility] = useState(false)
    const [status, setStatus] = useState([])
    const [ progress, setProgress] = useState(0)

    const onReady = (index) => {    
        console.log("set index ", index)
        let _status = [...status]
        _status[index] = true
        setStatus(_status)
    }

    const {locale} = useContext(SettingsContext)
    const {programs} = useContext(ProgramContext)
    const history = useHistory()

    useEffect(() => {
        // generate an array 
        if(programs?.length > 0 && status.length === 0){
            setStatus(Array(programs.length).fill(false, 0, programs.length ))
        }
    }, [programs])

    useEffect(() => {
        const prog = filter(status, ready => !!ready ).length / status.length
        console.log(prog)
        setProgress(prog * 100)
        const shouldDisplay = reduce(status, (result, next) => result && next)
        if(shouldDisplay){
            setVisibility(shouldDisplay)
        }
    }, [status])


    const renderPrograms = () => {
        console.log("Render")
        return(
            map(programs, (program, index) => {
                const onClick = () => {
                    history.push(`/program/${program.id}`)
                }
                return(
                    <Fader 
                        key={`program-${program?.id}`} 
                        index={index}
                        program={program} 
                        visible={visible}
                        onReady={onReady}
                        onClick={onClick}/>
                )
            })
        )
    }

    return(
        <div style={{
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}> 
            <Container>
                <Title>{locale.onDemand}</Title>
                {!visible && <Center>
                    <Fade in={!visible}>
                        <CircularProgress variant="determinate" value={progress} size={100}/>
                    </Fade>
                </Center>

                    }
                <Inner>
                       {status?.length > 0 && renderPrograms()}
                </Inner>
           

            </Container>

            <Footer />


        </div>
    )
}


const Fader = props => {
    const { program, visible, onClick, onReady, index} = props
    const delay = 50

    const _onReady = () => {
        onReady(index)
    }
    return(
        <>
            <Banner loaded={visible} delay={`${delay * index}ms`} src={program?.banner} onClick={onClick} onLoad={_onReady}/>
            <Poster loaded={visible} delay={`${delay * index}ms`} src={program?.thumbnail} onClick={onClick} onLoad={_onReady}/>
        </>
        )
}


